import { motion } from "framer-motion";
import { ImageIcon } from "lucide-react";
import { ModuleHeader } from "./VideoCarousel";
import { resolveMedia } from "@/api/client";
import { trJourney } from "@/config/journeyI18n";
import { useLanguage } from "@/context/LanguageContext";

// "The Arrival Photo Story" — a step-by-step visual narrative (delivery → altar
// → kirtan → prasadam) showing the host that everything is handled effortlessly.
export const PhotoStory = ({ module }) => {
  const { lang } = useLanguage();
  const steps = module.steps || [];
  if (!steps.length) return null;
  return (
    <div data-testid={`journey-story-${module.id}`} className="mx-auto max-w-5xl px-5">
      <ModuleHeader title={module.title} subtitle={module.subtitle} />
      <div className="mt-10 space-y-6">
        {steps.map((s, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.5, delay: i * 0.05 }}
            data-testid={`story-step-${i}`}
            className={`flex flex-col items-center gap-5 sm:flex-row ${
              i % 2 ? "sm:flex-row-reverse" : ""
            }`}
          >
            <div className="aspect-video w-full overflow-hidden rounded-2xl border border-amber-200/15 bg-gradient-to-br from-[#161d3b] to-[#0a0f24] sm:w-1/2">
              {s.image ? (
                <img src={resolveMedia(s.image)} alt="" loading="lazy" className="h-full w-full object-cover" />
              ) : (
                <div className="grid h-full w-full place-items-center text-amber-300/40">
                  <ImageIcon className="h-8 w-8" />
                </div>
              )}
            </div>
            <div className="flex items-center gap-4 sm:w-1/2">
              <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full border border-amber-300/40 font-display text-lg text-amber-200">
                {i + 1}
              </span>
              <p className="text-base text-amber-50/75">{trJourney(s.caption, lang)}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};
